// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: flex;
  flex-direction: column;
  color: white;
  font-family: "Qualcomm Next-Regular";
  height: 100vh;
}

.body {
  /*flex:1;*/
  color: rgba(0, 0, 0, 0.85);
  min-height: calc(-198px + 100vh) !important;
  overflow-y: auto;
}

.tab-body {
  margin-top: 3rem;
  margin-left: 2.25rem;
  margin-right: 3rem;
}

.footer {
  background: white;
  color: rgba(0, 0, 0, 0.85);
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  padding: 15px 24px;
  border-top: 1px solid rgb(233, 235, 238);
  font-family: "Arial Regular", "Helvetica Neue", Helvetica, sans-serif;
  flex-flow: column;
  height: 198px;
}

input {
  width: 100%;
  height: 100%;
  border-color: rgb(103, 114, 132);
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/components/assets/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,qEAAqE;EACrE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB","sourcesContent":[".App {\n  display: flex;\n  flex-direction: column;\n  color: white;\n  font-family: \"Qualcomm Next-Regular\";\n  height: 100vh;\n}\n\n.body {\n  /*flex:1;*/\n  color: rgba(0, 0, 0, 0.85);\n  min-height: calc(-198px + 100vh) !important;\n  overflow-y: auto;\n}\n\n.tab-body {\n  margin-top: 3rem;\n  margin-left: 2.25rem;\n  margin-right: 3rem;\n}\n\n.footer {\n  background: white;\n  color: rgba(0, 0, 0, 0.85);\n  display: flex;\n  flex-flow: column;\n  justify-content: space-between;\n  padding: 15px 24px;\n  border-top: 1px solid rgb(233, 235, 238);\n  font-family: \"Arial Regular\", \"Helvetica Neue\", Helvetica, sans-serif;\n  flex-flow: column;\n  height: 198px;\n}\n\ninput {\n  width: 100%;\n  height: 100%;\n  border-color: rgb(103, 114, 132);\n  border-radius: 4px;\n  border-style: solid;\n  border-width: 1px;\n  box-sizing: border-box;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
